// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-input-field .v-input__slot{box-shadow:none !important}.czt-input-field .v-input__slot .primary{background-color:#178fcf !important;border-color:#178fcf !important}.czt-input-field .v-input__slot .error--text{color:#ff0018 !important}.czt-input-field--error input{color:#ff0018 !important}.czt-input-field--light .v-text-field__details .success--text{color:#fff !important}.czt-input-field--light.v-text-field--outlined.v-input--is-focused fieldset{border-color:#178fcf}", ""]);
// Exports
module.exports = exports;
